<div class="modal-header">
    <h4>Clock In</h4>
</div>
<div class="modal-body">
    <div *ngIf="alert != null" class="alert alert-danger">
        {{ alert }}
        <button type="button" class="close" (click)="closeAlert()" style="font-size: 1rem;">
            <span class="oi oi-x"></span>
        </button>
    </div>

    <div class="card row" style="display:block;margin-bottom:15px;">
        <div style="margin-left: 15px;">
            <label>Trip:</label>
            <select class="form-control"
                    style="max-width:300px;"
                    [(ngModel)]="formData.selectedTrip"
                    (change)="getPayType()">
                <option *ngFor="let data of tripListFiltered" [ngValue]="data.Index">{{data.Display}}</option>
            </select>
        </div>
        <div style="margin-left: 15px;" *ngIf="formData.selectedTrip != null">
            <label>Scope:</label>
            <select class="form-control"
                    style="max-width:300px;"
                    [(ngModel)]="formData.selectedScope">
                <option *ngFor="let data of tripListFiltered[formData.selectedTrip].ScopeData" [ngValue]="data.SMWorkOrderScopeID">{{data.Scope}} - {{data.ScopeDescription}}</option>
            </select>
        </div>
        <div style="margin-left: 15px;" *ngIf="formData.selectedTrip != null && lookupReady">
            <label>Pay Type:</label>
            <select class="form-control"
                    style="max-width:300px;"
                    [(ngModel)]="formData.selectedPayType">
                <option *ngFor="let data of lookupList['SMPayType']" [ngValue]="data.Code">{{data.Code}} - {{data.CodeDescription}}</option>
            </select>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-text-primary" (click)="cancelClicked()">Close</button>
    <button type="button" class="btn btn-primary" (click)="clockInClicked()" 
            [disabled]="formData.selectedPayType == null || formData.selectedTrip == null || formData.selectedScope == null">
        Clock In
    </button>
</div>

